import React from "react";
import { Column } from "../../common/Table/Interfaces";
import { Declarant } from "../../../models/Declarant";
import DECLARANT_TABLE_COLUMNS from "../declarantTable/config";
import {
  DELETE_SIGMA_EVENT,
} from "../../../constants/events";
import {Nullable} from "../../../models/Common";
import TextArea from "../columns/textArea";
import {numberWithSpaces} from "../../../utils/amountTransformation";
import {warrantyFormat, warrantyValidation} from "./warranty";
import Convert from "../declarantTable/columns/convert";
import DeclarantActions from "../DeclarantActions";
import SettingsStore from "../../../stores/SettingsStore";

const COLUMNS = ((settingsStore: SettingsStore) => {
  let sigmaTableColumns = [] as Column[];
  let warranty: Nullable<Column>;
  DECLARANT_TABLE_COLUMNS().forEach(
      (column: Column) => {
        if(column.key === 'warranty') {
          warranty = Object.assign({}, column);
        } else {
          sigmaTableColumns.push(Object.assign({}, column));
        }
      }
  );

  let action = sigmaTableColumns.pop();
  let newAction = {
    ...action,
    render: (text, entity: Declarant) => {
      return (
        <DeclarantActions
          editEntity={{
            entity,
          }}
          deleteEntity={{ entityId: entity.id, eventKey: DELETE_SIGMA_EVENT }}
          settingsStore={settingsStore}
        />
      );
    },
  } as Column;

  let newWarranty: Nullable<Column>;

  if(warranty) {
    newWarranty = {
      ...warranty,
      render: (text, entity: Declarant) => {
        return (
          <div className="warranty-container">
            <div style={{ width: '100%' }}>
              <TextArea
                string={numberWithSpaces(text)}
                entityKey={'warranty'}
                entityId={entity.id}
                validation={warrantyValidation}
                format={warrantyFormat}
              />
            </div>
            <Convert
              checked={entity.is_warranty_convert}
              entityKey="is_warranty_convert"
              entityId={entity.id}
              tooltip={"Convert to EUR."}
            />
          </div>
        );
      },
    } as Column;
  }

  sigmaTableColumns.push(newAction);
  if(newWarranty) {
    sigmaTableColumns.push(newWarranty);
  }

  return sigmaTableColumns as Column[];
});

export default COLUMNS;
